export default __webpack_public_path__ + "static/media/lubbers-logo.aa37acfb.svg";